import * as solidIcons from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import './faIcon.css';

export type FAIconName = keyof Omit<typeof solidIcons, 'prefix' | 'fas'>;

interface Props extends Omit<FontAwesomeIconProps, 'icon'> {
  iconName: FAIconName;
  disabled?: boolean;
}

export function AfbFAIcon({ onClick, disabled, ...rest }: Props) {
  const style = {
    paddingTop: '3px',
    paddingInlineEnd: '3px',
    color: '#007dc3',
    cursor: '',
  };
  if (disabled) {
    style.color = '#999';
    onClick = undefined;
  }
  if (onClick) style.cursor = 'pointer';
  return <FAIcon size={'sm'} style={style} onClick={onClick} {...rest} />;
}

export function FACloseIcon({ size, style, onClick }: Omit<Props, 'iconName'>) {
  return (
    <FAIcon
      className="diremo-icon-close"
      iconName="faWindowClose"
      size={size ?? 'xl'}
      style={style}
      onClick={onClick}
    />
  );
}

export function FASpinnerIcon({ size, color, style }: Omit<Props, 'iconName'>) {
  return (
    <FAIcon
      iconName="faSpinner"
      spin={true}
      color={color ?? 'white'}
      size={size ?? '4x'}
      style={style ?? { position: 'fixed', top: 30, zIndex: 10001 }}
    />
  );
}

export default function FAIcon({ iconName, ...rest }: Props) {
  return <FontAwesomeIcon icon={solidIcons[iconName]} {...rest} />;
}
